import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCustomerCardStateAction } from '@makemydeal/dr-sales-checkin-store';
import { ConversationTypeEnum, CustomerCardState, DeepLinks } from '@makemydeal/dr-sales-checkin-types';

export const useShareCreditAppLink = () => {
    const dispatch = useDispatch();

    const shareCreditAppLink = useCallback(() => {
        dispatch(
            setCustomerCardStateAction(CustomerCardState.INBOX, {
                defaultTab: 'inbox',
                occDefaultTab: ConversationTypeEnum.TEXT,
                message: DeepLinks.CreditApp
            })
        );
    }, [dispatch]);

    return { shareCreditAppLink };
};
